import React, {useState} from "react";
import Sidebar from "./Sidebar";
import Dashboard from "./Dashboard";
import {SelectedView, TreeNode, VersionData} from "../types/types";
import './componentsCSS/DatasetsView.css';
import {findNodeById, findPath} from "../utils/treeUtils";
import VersionsSelect from "./VersionsSelect";

interface SourcesViewProps {
    data: any,
    versions: VersionData[],
    selectedVersion: string | null,
    setSelectedVersion: (version: string) => void,
    view: SelectedView,
}

const DatasetsView: React.FC<SourcesViewProps> = ({
                                                      data,
                                                      versions,
                                                      selectedVersion,
                                                      setSelectedVersion,
                                                  }) => {
    const [selectedNode, setSelectedNode] = useState<TreeNode | null>(null);

    const handleSelect = (newValue: string) => {
        if (!newValue) {
            setSelectedNode(null);
            return;
        }

        const selectedNode = findNodeById(newValue, data);
        const path = findPath(data, newValue);

        if (selectedNode && path) {
            selectedNode.path = path;
            setSelectedNode(selectedNode);
        }
    };


    return (
        <div className="sources-container">
            <Sidebar selectedNode={selectedNode} handleSelect={handleSelect} data={data}/>
            <Dashboard selectedNode={selectedNode} handleSelect={handleSelect}/>

            <VersionsSelect
                versions={versions}
                selectedVersion={selectedVersion}
                setSelectedVersion={setSelectedVersion}
            />

        </div>
    );
}

export default DatasetsView;